module.exports = __webpack_public_path__ + "static/prompt-enhancer-demo-thumb-e1c87a47c2bdc70f1c890f8bb894ccf5.png";